import React from 'react';
import { ServiceLandingHero } from '../components/ServiceLandingHero';
import { ArrowRightIcon } from 'lucide-react';
import { landDevelopmentPage } from '../data/landDevelopment';
export function LandDevelopmentPage() {
  const {
    hero,
    services,
    support
  } = landDevelopmentPage;
  return <>
      {/* Service landing hero */}
      <ServiceLandingHero id="top" eyebrow={hero.eyebrow} title={hero.title} intro={hero.intro} image={hero.image} alt={hero.alt} tone="ivory" data-id="element-630" data-mp="jmbf8rl0ghf5" />

      {/* Three-part service directory */}
      <section aria-labelledby="land-services-title" className="section-y bg-ivory" data-id="element-631" data-mp="3s47t6bitqoay">
        <div className="site-container" data-id="element-632" data-mp="xej0i61zeua">
          <div className="grid gap-5 lg:grid-cols-12 lg:items-end lg:gap-14" data-id="element-633" data-mp="y6dtqrtt8ji">
            <h2 id="land-services-title" className="section-title text-charcoal lg:col-span-7" data-id="element-634" data-mp="3j2rhm0g9wg55">
              {services.title}
            </h2>
            <p className="max-w-[460px] text-[16px] leading-relaxed text-charcoal/75 lg:col-span-5" data-id="element-635" data-mp="3o1b3y1ys3ty1">{services.intro}</p>
          </div>

          <div className="mt-10 grid border-t-2 border-olive md:grid-cols-3 lg:mt-14" data-id="element-636" data-mp="33a903axddk2v">
            {services.groups.map((group, i) => <section key={group.id} id={group.id} aria-labelledby={`${group.id}-title`} className={`border-b border-charcoal/15 py-8 md:border-b-0 md:py-10 ${i > 0 ? 'md:border-l md:pl-8 lg:pl-10' : ''} ${i < services.groups.length - 1 ? 'md:pr-8 lg:pr-10' : ''}`} data-id="element-637" data-mp="3h8ffnaygaxdq" data-mpi={i}>
                <h3 id={`${group.id}-title`} className="font-display text-[28px] font-medium leading-[1.12] text-charcoal lg:text-[32px]" data-id="element-638" data-mp="2yb5sbiq08zr7">
                  {group.title}
                </h3>
                <ul className="mt-6 border-t border-charcoal/10" data-id="element-639" data-mp="25sie8n9fekzm">
                  {group.items.map(item => <li key={item} className="flex min-h-[48px] items-start gap-3 border-b border-charcoal/10 py-3 text-[16px] leading-[1.5] text-charcoal/85" data-id="element-640" data-mp="4sdh4xtdp3z0">
                      <span className="mt-[10px] h-1 w-1 shrink-0 rounded-full bg-moss" aria-hidden="true" data-id="element-641" data-mp="ehnbylflx0qt" />
                      <span data-id="element-642" data-mp="ik0fd36vsmkf">{item}</span>
                    </li>)}
                </ul>
              </section>)}
          </div>
        </div>
      </section>

      {/* Related active-site support */}
      <section aria-labelledby="land-support-title" className="border-t border-charcoal/10 bg-stone/70" data-id="element-643" data-mp="3myic3t50s717">
        <div className="site-container grid gap-5 py-12 md:py-14 lg:grid-cols-12 lg:items-center lg:gap-14" data-id="element-644" data-mp="3qy8yzlrfe30g">
          <h2 id="land-support-title" className="font-display text-[28px] font-medium leading-[1.12] text-charcoal sm:text-[32px] lg:col-span-4" data-id="element-645" data-mp="3vwkbk493urmd">
            {support.title}
          </h2>
          <p className="max-w-[560px] text-[16px] leading-relaxed text-charcoal/75 lg:col-span-5" data-id="element-646" data-mp="1lccvtcd1wfqa">{support.text}</p>
          <a href={support.link.href} className="focus-ring group inline-flex min-h-[44px] items-center gap-2 text-[15px] font-medium text-olive lg:col-span-3 lg:justify-self-end" data-id="element-647" data-mp="1gcrpuhzgr742">
            <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-648" data-mp="17jwt6co2ajpw">
              {support.link.label}
            </span>
            <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-649" data-mp="xn1xe1j6axfb" />
          </a>
        </div>
      </section>
    </>;
}